<template>
  <div class="basic-task">
    <div v-for="(item, index) in taskList" :key="index" class="task-one"
      :class="item.process ? 'finished' : index === curIndex ? 'ing' : ''">
      {{ index + 1 }}.{{ item.name }}
      <div class="box">
        <div v-if="!item.process"></div>
        <i v-else class="icon iconfont icon-duigou" style="color: #fff"></i>
      </div>
    </div>
    <div class="line"></div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    curIndex: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      taskList: [],
      speenInfo: null,
    };
  },
  computed: {
    applyCompanyId () {
      return this.$route.query.applyCompanyId;
    },
    applyCompanyOrderId () {
      return this.$route.query.applyCompanyOrderId;
    },
  },
  methods: {
    ...mapActions({
      getApplyFlow: "commonFill/getApplyFlow",
      getApplyFlowSpeed: "commonFill/getApplyFlowSpeed",
    }),
    async init () {
      let taskList = await this.getApplyFlow();
      this.taskList = taskList;
      if (this.applyCompanyId) {
        let info = await this.getApplyFlowSpeed(this.applyCompanyId);
        if (info && info.info) {
          this.speenInfo = info.info;
          console.log('taskList:', this.taskList, 'speenInfo: ', this.speenInfo);
          if (this.taskList && this.taskList.length > 0) {
            this.taskList.map((c) => {
              if (this.speenInfo && this.speenInfo.speed >= c.speed) {
                c.process = true;
              }
            });
          }
        }
      }
    }
  },
  created () {
    this.init();
  },
}

</script>

<style lang="scss" scoped>
.basic {
  &-task {
    width: 100%;
    margin: 50px 0 50px;
    padding: 0 80px;
    display: flex;
    justify-content: space-between;
    color: #666;
    position: relative;

    .task-one {
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 2;

      .box {
        width: 20px;
        height: 20px;
        background-color: #fff;
        box-shadow: 0px 2px 5px 0px rgba(1, 53, 97, 0.5);
        border-radius: 50%;
        margin-top: 10px;

        div {
          width: 14px;
          height: 14px;
          background-color: #8ba5bc;
          border-radius: 50%;
          margin: 3px auto 0;
        }
      }
    }

    .line {
      height: 8px;
      background-color: #d7dee4;
      position: absolute;
      width: 998px;
      left: 108px;
      top: 37px;
      z-index: 1;
    }

    .ing {
      color: rgba(0, 161, 233, 1);

      .box {
        div {
          background-color: rgba(0, 161, 233, 1);
        }
      }
    }

    .finished {
      color: rgba(0, 161, 233, 1);

      .box {
        background-color: rgba(0, 161, 233, 1);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
